import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import {
  RELATION_TYPES_RESOURCE,
  RELATION_TYPE_RESOURCE,
  UPDATE_RELATION_TYPE_RESOURCE,
} from '../constants';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_RELATION_TYPE_RESOURCE,
      method: 'put',
      request: (id, body, callback, t) => ({
        url: apiRoutes.relationTypes(id),
        body,
        meta: {
          callback,
          updateOtherList: {
            resource: RELATION_TYPES_RESOURCE,
            id,
            idProp: 'id',
          },
          setOther: { resource: RELATION_TYPE_RESOURCE },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateRelationTypeFailed'),
            onSuccessMessage: t('updateRelationTypeSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);
